import { createContext, useContext } from 'react';

import { RoomStatus, VideoSource } from '@features/video/types';

export type VideoStreamContextValue = {
  // участнику нужен видеоконтроль: включен в настройках, время пришло, он не сеансер
  visible: boolean;
  // по всем видимым камерам: хоть одна с этого устройства — device, иначе хоть одна
  // с телефона — other
  source: VideoSource;
  // одна из требуемых камер не настроена, хотя другая уже снимает: акцент на кнопке
  missing: boolean;
  // состояние комнаты, когда снимает это устройство
  status?: RoomStatus;
  // связь с комнатой потеряна
  error: boolean;
  // камеры с этого устройства в эфире, выключенные игроком или судьей: камера — любая из них,
  // микрофон — все
  micOff: boolean;
  camOff: boolean;
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  toggleModal: () => void;
};

export const VideoStreamContext = createContext<VideoStreamContextValue | null>(null);

// null вне турнирных страниц: виджеты игры живут и без видеоконтроля
export function useVideoStreamCtx(): VideoStreamContextValue | null {
  return useContext(VideoStreamContext);
}
